import logo from 'assets/icons/login/logo.svg';
import unsuccessfulImage from 'assets/images/vendor-register/unsuccess.svg';

const UnsuccessfulRegistration: React.FC = () => {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center overflow-y-auto">
      <header className="flex h-25 items-center justify-center">
        <img src={logo} alt="نما" />
      </header>
      <img className="mb-4" src={unsuccessfulImage} alt="" aria-hidden />
      <h1 className="text-subtitle-lg text-neutral-fg">ثبت نام انجام نشد!</h1>
      <p className="text-body-sm text-gray-08">
        متأسفانه در حال حاضر امکان همکاری با شما وجود ندارد.
      </p>
    </div>
  );
};

export default UnsuccessfulRegistration;
